<div
  class="radio-button-card my-2 px-2 py-2 md:p-4 border-round cursor-pointer"
  [ngClass]="{ selected: isSelected, disabled: disabled }"
  (click)="handleSelectWrapper()"
  data-cy="radio-button-card-container"
>
  <ng-content select="[slot=header]"></ng-content>
  <div [class]="centerVertically ? 'flex align-items-center' : 'flex align-items-start'">
    <p-radioButton
      styleClass="mr-2"
      [formControl]="control"
      [name]="name"
      [value]="value"
      [disabled]="disabled"
      [ariaLabel]="ariaLabel"
      [attr.data-cy]="'radio-button-card' + value"
    ></p-radioButton>
    <ng-content></ng-content>
  </div>
</div>
